<template>
    <b-row align-v="end">
        <b-col cols="12" md="4">
            <app-form-select-input
                label="Tipo"
                :options="itemTypes"
                @change="onItemTypeChange"
                v-model="filters.itemTypeId"
            />
        </b-col>
        <b-col cols="12" md="4">
            <app-form-select-input
                label="Subtipo"
                :options="itemSubTypes"
                v-model="filters.itemSubTypeId"
            />
        </b-col>
        <b-col cols="12" md="4">
            <app-form-text-input label="Serial" v-model="filters.serial" />
        </b-col>
        <b-col cols="12" md="4">
            <app-form-select-input
                :options="brands"
                v-model="filters.itemBrandId"
                label="Marca"
            />
        </b-col>
        <b-col cols="12" md="8" class="d-flex justify-content-end">
            <b-button variant="primary" @click="onFilter" class="mr-2"
                ><i class="fa fa-filter"></i
            ></b-button>
            <b-button variant="secondary" @click="clearFilters"
                ><i class="fa fa-times-circle"></i
            ></b-button>
        </b-col>
    </b-row>
</template>
<script>
import itemsRepository from '../../../../repositories/items.repository.js'
export default {
    props: {
        itemTypes: {
            required: true,
            type: Array,
        },
    },

    data() {
        return {
            filters: {
                itemTypeId: '',
                itemSubTypeId: '',
                serial: '',
                itemBrandId: '',
            },
            itemSubTypes: [],
            brands: [],
        }
    },

    methods: {
        async loadSubTypesByItemType(itemTypeId) {
            if (!itemTypeId) return

            this.itemSubTypes = await this.get('item-sub-types', { itemTypeId })
        },
        onFilter() {
            this.$emit('filter', this.filters)
        },
        clearFilters() {
            Object.keys(this.filters).map(key => (this.filters[key] = ''))
            this.$emit('filter', null)
        },
        async loadItemBrands(itemTypeId) {
            this.brands = await this.get('item-brands', { itemTypeId })
        },
        onItemTypeChange(itemTypeId) {
            this.loadSubTypesByItemType(itemTypeId)
            this.loadItemBrands(itemTypeId)
        },
    },
}
</script>
